import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/data";

const SECTIONS = [
  {
    title: "1. Verantwortlicher",
    body: `Verantwortlich für die Datenverarbeitung auf dieser Website ist: ${COMPANY.owner}, ${COMPANY.fullName}, ${COMPANY.street}, ${COMPANY.city}, Telefon: ${COMPANY.phone}, E-Mail: ${COMPANY.email}.`,
  },
  {
    title: "2. Erhebung und Verarbeitung von Daten",
    body: "Diese Website verwendet keine Cookies und kein Tracking. Personenbezogene Daten werden nur verarbeitet, wenn Sie uns diese aktiv über das Kontaktformular, per E-Mail oder telefonisch mitteilen: Name, E-Mail-Adresse, Telefonnummer sowie Ihre Nachricht. Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage und zur Angebotserstellung auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.",
  },
  {
    title: "3. Speicherung und Empfänger",
    body: "Ihre Anfrage wird per E-Mail an uns übermittelt und zur Bearbeitung sowie zur Nachverfolgung gespeichert. Eine Weitergabe an Dritte erfolgt nicht, es sei denn, dies ist zur Vertragserfüllung erforderlich oder wir sind gesetzlich dazu verpflichtet. Ihre Daten werden gelöscht, sobald sie für die genannten Zwecke nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.",
  },
  {
    title: "4. Hosting",
    body: "Diese Website wird bei einem Hosting-Dienstleister betrieben. Beim Aufruf der Website werden technisch notwendige Verbindungsdaten (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs) in Server-Logdateien verarbeitet (Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse am sicheren Betrieb der Website).",
  },
  {
    title: "5. Ihre Rechte",
    body: "Sie haben das Recht auf Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO), auf Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch gegen die Verarbeitung (Art. 21). Wenden Sie sich hierzu jederzeit an die oben genannte E-Mail-Adresse. Zudem haben Sie das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren (für Nordrhein-Westfalen: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW).",
  },
];

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans text-slate-900" data-testid="datenschutz-page">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
        <a href="/" data-testid="datenschutz-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-sky-700 hover:text-sky-800">
          <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
        </a>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-sky-800">Rechtliches</p>
        <h1 className="mt-3 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">Datenschutzerklärung</h1>
        <p className="mt-4 text-sm text-slate-500">Stand: September 2026</p>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-serif text-xl font-medium text-slate-900">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
